import { NgIf } from '@angular/common';
import { NgModule } from '@angular/core';

import { ConfirmationComponent } from './confirmation.component';
import { NgbModalModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '@ngx-translate/core';
import { InlineSVGModule } from 'ng-inline-svg-2';

@NgModule({
  imports: [
    NgbModalModule,
    TranslateModule,
    NgIf,
    InlineSVGModule,
  ],
  exports: [ConfirmationComponent],
  declarations: [ConfirmationComponent],
  providers: [],
})
export class ConfirmationModule { }
